import { Flex, Box, Text, Heading, Image } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Logo from '../../assets/musa-logo-variation-1.svg';

export function AuthLayout() {
    return (
        <Flex w="100%" h="100vh" gradientFrom="purple.100" gradientVia="white" gradientTo="purple.200" bgGradient="to-br">
            <Flex display={{ base: 'none', md: 'unset' }} position="relative" flexBasis="60%">
                <Box
                    position="absolute"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    gradientFrom="purple.800"
                    gradientTo="rgb(244,244,245)"
                    gradientVia="purple.400"
                    bgGradient="to-r"
                    zIndex="1"
                />
                <Box
                    animation="pulse"
                    position="absolute"
                    inset={0}
                    bg="white"
                    opacity={0.1}
                    rounded="full"
                    w="50%"
                    h="50%"
                    left="50%"
                    transform="translate(-50%, -50%) scaleX(1) scaleY(1)"
                    filter="blur(64px)"
                    top="50%"
                    zIndex="2"
                />
                <Flex
                    position="relative"
                    zIndex={10}
                    h="100%"
                    color={{ base: 'white' }}
                    justifyContent="center"
                    alignItems="center"
                    px="15px">
                    <Flex zIndex={10} maxW="430px" flexDirection="column" gap="16px" alignItems="center">
                        <Image src={Logo} alt="MUSA EHR Logo" width={240} height={144} />
                        <Heading as="h2" fontWeight="700" fontSize="30px" textAlign="center">
                            Welcome to MUSA EHR
                        </Heading>
                        <Text fontWeight="700" color={{ base: 'white' }} fontSize="18px" textAlign="center">
                            Streamline your medical record management with our state-of-the-art Electronic Health Records system.
                        </Text>
                    </Flex>
                </Flex>
            </Flex>
            <Flex
                flexBasis={{ base: '100%', md: '40%' }}
                bg={{ base: 'transparent', md: 'rgb(244,244,245)' }}
                flexDirection="column"
                alignItems="center">
                <Flex
                    p="10px"
                    maxW="400px"
                    w="100%"
                    h="100%"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent={{ base: 'space-between', md: 'center' }}>
                    <Image display={{ base: 'unset', md: 'none' }} src={Logo} alt="MUSA EHR Logo" width={240} height={144} />
                    <Box w="100%">
                        <Outlet />
                    </Box>
                    <Box display={{ base: 'unset', md: 'none' }} visibility="hidden" h="300px" w="100%" />
                </Flex>
            </Flex>
        </Flex>
    );
}
